import queryString from "query-string";
import { useTranslation } from "react-i18next";

import { withTenantSamlContext } from "../../context_providers/TenantSamlContext";

import { LoginWrapper } from "./Common";
import SimpleLogin from "./SimpleLogin";
import SSOLogin from "./SSOLogin";

import { ErrorBanner, SuccessBanner } from "pstat-design-system/banner";
import sanitize from "pstat-anywhere/utils/sanitize";

const LoginForm = props => {
  const { samlSettings, cleanBorders, onLoginHelpClicked } = props;
  const { t } = useTranslation();

  const parsed = queryString.parse(window.location.search);

  let ssoUsernameInvalid;
  const isLogout = parsed["lo"];
  const isErrorSsoUri = parsed["sso"];
  const isErrorSsoUsername = parsed["sso_username"];
  const isErrorSsoUserAuthFailed = parsed["sso_user_auth_failed"];
  const isErrorSsoUsernameInvalid = sanitize(parsed["sso_username_invalid"]);
  if (isErrorSsoUsernameInvalid) {
    ssoUsernameInvalid = atob(isErrorSsoUsernameInvalid);
  }
  const isErrorSsoSamlResponseStatusError = sanitize(
    parsed["saml_response_status_error"]
  );

  return (
    <LoginWrapper my={props.my | 0} width={props.width}>
      {isLogout && (
        <SuccessBanner message={t("authentication.loginForm.logoutMessage")} />
      )}
      {isErrorSsoUri && (
        <ErrorBanner message={t("authentication.loginForm.errorSsoUri")} />
      )}
      {isErrorSsoUsername && (
        <ErrorBanner message={t("authentication.loginForm.errorSsoUsername")} />
      )}
      {isErrorSsoUserAuthFailed && (
        <ErrorBanner
          message={t("authentication.loginForm.errorSsoUserAuthFailed")}
        />
      )}
      {isErrorSsoUsernameInvalid && (
        <ErrorBanner
          message={t("authentication.loginForm.errorSsoUsernameInvalid", {
            username: ssoUsernameInvalid
          })}
        />
      )}
      {isErrorSsoSamlResponseStatusError && (
        <ErrorBanner
          message={t(
            "authentication.loginForm.errorSsoSamlResponseStatusError"
          )}
        />
      )}
      {samlSettings && samlSettings.isActive ? (
        <SSOLogin
          samlSettings={samlSettings}
          hardRedirect={props.hardRedirect}
        />
      ) : (
        <SimpleLogin
          cleanBorders={cleanBorders}
          onLoginHelpClicked={onLoginHelpClicked}
        />
      )}
    </LoginWrapper>
  );
};

export default withTenantSamlContext(LoginForm);
